import React from "react";
import { EPAGE } from "../../types";
import Header from "../../sections/Header/Header";
import Main from "../../sections/Main/Main";
import Footer from "../../sections/Footer/Footer";

const Error: React.FC = () => (
    <div className="wrapper">
        <Header />
        <Main page={EPAGE.ERROR} />
        <Footer />
    </div>
);

export default Error;